export default __webpack_public_path__ + "static/media/second.2fa319f6.svg";